import { SxProps, Theme } from '@mui/material/styles';

export type Card = {
  id: string;
  image: string;
  name: string;
  shop?: {
    href: string;
    video?: {
      horizontal?: boolean;
      src: string;
    };
  };
  short: string;
  texts?: string[];
  texts1?: string[];
  texts2?: string[];
  texts3?: string[];
  video?: {
    horizontal?: boolean;
    src: string;
  };
};

export enum CardType {
  Feature = 'feature',
  Principle = 'principle',
}

export type CardDeckProps = {
  cards: Card[];
  onCardClick?: (id: string) => void;
  sx?: SxProps<Theme>;
};

export enum ScrollDirection {
  Left = 'left',
  Right = 'right',
}
